var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgOurPhilosophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1500 1436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.52868,0,0,1.52868,-0.000528587,49.2921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.438,505.576C19.19,380.031 -36.363,242.304 35.345,132.777C106.906,23.475 254.627,14.499 384.827,3.993C511.396,-6.22 638.913,-1.34 739.72,75.939C863.781,171.045 981.364,299.266 973.682,455.413C965.474,622.244 848.148,765.938 701.818,846.339C562.682,922.787 389.601,927.636 249.179,853.493C125.859,788.379 96.114,639.302 56.438,505.576Z",
    style: {
      fill: "rgb(199,244,253)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.52868,0,0,1.52868,59.9891,-0.000143971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.72,450.854C4.923,320.857 -26.889,175.796 62.076,79.757C150.858,-16.085 298.008,-0.306 428.137,11.042C554.637,22.073 679.556,48.145 766.068,141.149C872.537,255.608 967.096,401.638 933.489,554.318C897.582,717.446 757.94,839.567 600.254,894.447C450.32,946.629 278.853,922.553 152.758,826.036C42.019,741.274 37.545,589.324 20.72,450.854Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(61,190,173)",
      strokeWidth: 3
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgOurPhilosophy);
export default __webpack_public_path__ + "static/media/bg-our-philosophy.e4c955dae6db703f06ed8ee7e622a761.svg";
export { ForwardRef as ReactComponent };